export default __webpack_public_path__ + "static/media/037-window.c228892f.svg";